import { DEBT_TYPE, INTEREST_RATE_DEFAULT } from '@funnels/constants';

export default function getDefaultInterestRate(debtType: DEBT_TYPE) {
  switch (debtType) {
    case DEBT_TYPE.CAR:
      return INTEREST_RATE_DEFAULT.CAR;
    case DEBT_TYPE.CREDIT:
      return INTEREST_RATE_DEFAULT.CREDIT;
    case DEBT_TYPE.MORTGAGE:
      return INTEREST_RATE_DEFAULT.MORTGAGE;
    case DEBT_TYPE.OTHER:
      return INTEREST_RATE_DEFAULT.OTHER;
    case DEBT_TYPE.PERSONAL:
      return INTEREST_RATE_DEFAULT.PERSONAL;
    // Doesnt appear to be a deafult interest rate for store
    case DEBT_TYPE.STORE:
    default:
      return INTEREST_RATE_DEFAULT.MORTGAGE;
  }
}
